"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("reshow-runtime/helpers/toConsumableArray"));
// @ts-check

/**
 * @param {any[]} array
 * @param {boolean} [reverse]
 * @param {Function} [cb]
 * @returns {any[]}
 */
var dedup = function dedup(array, reverse, cb) {
  if (!array || !array.filter) {
    return array;
  }
  var exists = Object.create(null);
  var handelFilter = function handelFilter( /**@type any*/item) {
    var val = cb ? cb(item) : item;
    if (exists[val]) {
      return false;
    } else {
      exists[val] = true;
      return true;
    }
  };

  // This way could keep array in same position
  if (reverse) {
    return (/**@type any[]*/(0, _toConsumableArray2["default"])(array).reverse().filter(handelFilter).reverse()
    );
  } else {
    return (/**@type any[]*/array.filter(handelFilter)
    );
  }
};
var _default = exports["default"] = dedup;
module.exports = exports.default;